<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_parents'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="d-flex justify-content-end">
                <div>
                  <b-button size="lg" variant="info" v-b-modal.add-parent
                    ><i class="mdi mdi-plus"></i> Add Parent</b-button
                  >
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Found</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(name)="data">
                    <b>{{ data.item.parent.name }}</b>
                  </template>
                  <template #cell(gender)="data">
                    {{ data.item.parent.gender }}
                  </template>
                  <template #cell(telephone)="data">
                    {{ data.item.parent.telephone }}
                  </template>
                  <template #cell(address)="data">
                    {{ data.item.parent.address }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button
                        @click="view(data.item)"
                        type="button"
                        class="btn-sm btn"
                        variant="info"
                        v-b-modal.view-students
                      >
                        <i class="mdi mdi-eye"></i>
                      </b-button>
                      <b-button
                        @click="asign(data.item.parent.id)"
                        type="button"
                        class="btn-sm btn"
                        variant="success"
                        v-b-modal.asign-students
                      >
                        <i class="mdi mdi-account-multiple-plus"></i>
                      </b-button>
                      <b-button
                        @click="
                          edit(
                            data.item.parent.id,
                            data.item.parent.name,
                            data.item.parent.gender,
                            data.item.parent.telephone,
                            data.item.parent.address,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="primary"
                        v-b-modal.edit-parent
                      >
                        <i class="mdi mdi-square-edit-outline"></i>
                      </b-button>
                      <b-button
                        @click="
                          remove(data.item.parent.id, data.item.parent.name)
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.delete
                      >
                        <i class="mdi mdi-trash-can"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="view-students"
        centered
        title="View Children"
        title-class="font-14"
        hide-footer
      >
        <table
          class="table table-sm mt-2"
          style="color: black;"
          density="compact"
        >
          <thead>
            <tr>
              <th>Name</th>
              <th>Student ID</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in student" :key="item.id">
              <td>{{ item.last_name }} {{ item.first_name }}</td>
              <td>{{ item.student_id }}</td>
            </tr>
          </tbody>
        </table>
        <!-- <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30"
            variant="secondary"
            @click="$bvModal.hide('view-students')"
            >Close</b-button
          >
        </div> --> </b-modal
      ><b-modal
        id="asign-students"
        centered
        title="Asign Another Student to Parent / Guardian"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="asignStudent">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />

            <label>Student : <small class="text-primary"></small></label>
            <multiselect
              v-model="student"
              :options="students"
              placeholder="Select Student"
              :custom-label="customLabel"
            ></multiselect>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('asign-student')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="add-parent"
        centered
        title="Add Parent / Guardian"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="addParent">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <label>Name</label>
            <input v-model="name" type="text" class="form-control" />
            <label>Gender</label>
            <select class="form-control" v-model="gender"
              ><option>Female</option
              ><option>Male</option></select
            >
            <label>Telephone</label>
            <input v-model="telephone" type="number" class="form-control" />
            <label>Email Address</label>
            <input v-model="address" type="email" class="form-control" />
            <label>Student : <small class="text-primary"></small></label>
            <multiselect
              v-model="student"
              :options="students"
              placeholder="Select Student"
              :custom-label="customLabel"
            ></multiselect>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('add-parent')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-parent"
        centered
        title="Edit Parent / Guardian"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="editParent">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <label>Name</label>
            <input v-model="name" type="text" class="form-control" />
            <label>Gender</label>
            <select class="form-control" v-model="gender"
              ><option>Female</option
              ><option>Male</option></select
            >
            <label>Telephone</label>
            <input v-model="telephone" type="number" class="form-control" />
            <label>Email Address</label>
            <input v-model="address" type="email" class="form-control" />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-parent')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-parent"
        centered
        title="Delete Parent / Guardian"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeParent">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Parent / Guardian :
          <b>{{ name }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-parent')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  parentComputed,
  parentMethods,
  studentMethods,
  studentComputed,
} from "@/state/helpers";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Parents",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Parents / Guardians",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Parents / Guardians", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "name", label: "Name", visible: true },
        { key: "gender", label: "Gender", visible: true },
        { key: "telephone", label: "Telephone", visible: true },
        { key: "address", label: "Email Address", visible: true },
        { key: "student", label: "Student", visible: false },
        { key: "actions", label: "Actions", visible: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      id: "",
      name: "",
      gender: "",
      telephone: "",
      address: "",
      student: "",
    };
  },
  computed: {
    ...parentComputed,
    ...studentComputed,
    List() {
      return this.parents.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.parents.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.parents.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchParents();
    this.fetchStudents();
    this.TotalRows = this.parents.length;
    this.isBusy = false;
    //this.schoolterm = this.schoolterms.find((option) => option.active == 1);
  },
  methods: {
    ...parentMethods,
    ...studentMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    view(data) {
      this.student = data.children;
      this.$bvModal.show("view-students");
    },
    asign(id) {
      this.id = id;
      this.$bvModal.show("asign-students");
    },
    edit(id, name, gender, telephone, address) {
      this.id = id;
      this.name = name;
      this.gender = gender;
      this.telephone = telephone;
      this.address = address;
      this.$bvModal.show("edit-parent");
    },
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show("delete-parent");
    },
    customLabel(student) {
      return `${student.student.first_name} ${student.student.last_name} ${student.class.name} ${student.stream.name}`;
    },
    async addParent() {
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("gender", this.gender);
      formData.append("telephone", this.telephone);
      formData.append("address", this.address);
      formData.append("student", this.student.student.student_id);
      let url = "/addparent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          if (response.data.error) {
            this.$swal({
              title: "Error",
              text: response.data.error,
              icon: "error",
            });
          } else {
            this.fetchParents();
            this.$bvModal.hide("add-parent");
            this.name = "";
            this.gender = "";
            this.telephone = "";
            this.address = "";
            this.student = "";
            this.$swal({
              title: "Success",
              text: response.data.message,
              icon: "success",
            });
          }
        }
      });
    },
    async editParent() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("gender", this.gender);
      formData.append("telephone", this.telephone);
      formData.append("address", this.address);
      let url = "/updateparent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchParents();
          this.$bvModal.hide("edit-parent");
          this.name = "";
          this.gender = "";
          this.telephone = "";
          this.address = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeParent() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeparent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchParents();
          this.$bvModal.hide("delete-parent");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },

    async asignStudent() {
      let formData = new FormData();
      formData.append("parent_id", this.id);
      formData.append("student_id", this.student.student.student_id);
      let url = "/assignstudenttoparent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchParents();
          this.$bvModal.hide("asign-students");
          this.student = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
};
</script>
